import React from 'react';
import { observer } from 'mobx-react';
import clsx from 'clsx';
import Url from 'environment';
import style from './style.module.scss';

const LolViewSetPickPlayer = observer(({ item }) => {
  const { location, name, champ, kda } = item;

  if (!!champ) {
    return (
      <div className={clsx(style.item, style[location])}>
        <span className={style.player}>{name.length > 6 ? name.slice(0, 6) + '..' : name}</span>
        <span className={style.champ}>
          <img src={`${Url.thumb}/0x45${champ.imgPath}`} alt='champion image' />
          <span>{champ.name.length > 6 ? champ.name.slice(0, 4) + '..' : champ.name}</span>
        </span>
        <span className={style.kda}>{kda}</span>
      </div>
    );
  } else {
    return null;
  }
});

export default LolViewSetPickPlayer;
